import { render } from "./FooterDashboard.vue?vue&type=template&id=527dd2ae"
import script from "./FooterDashboard.vue?vue&type=script&lang=js"
export * from "./FooterDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__